import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnVG: CultureInfo = {
  name: 'en-VG',
  displayName: 'English (British Virgin Islands)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-VG',
  parent: CultureInfoEn
};
